import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidateEmailPatternDirective } from './validate-email-pattern.directive';

@NgModule({
  declarations: [ValidateEmailPatternDirective],
  exports: [ValidateEmailPatternDirective],
  imports: [
    CommonModule
  ]
})
export class ValidatorsModule { }
